import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  de: {
    translation: {
      "landing": {
        "hero_title": "Die moderne Cloud-Kasse für Österreich",
        "hero_subtitle": "RKSV-konform, offline-fähig und kinderleicht zu bedienen. Starten Sie jetzt in die Zukunft Ihres Unternehmens.",
        "cta_start": "Kostenlos testen",
        "features_title": "Alles was Sie brauchen",
        "feature_fiscal": "RKSV Konform",
        "feature_fiscal_desc": "Voll integrierte fiskaltrust-Signatur für absolute Rechtssicherheit.",
        "feature_offline": "Offline Modus",
        "feature_offline_desc": "Arbeiten Sie einfach weiter, auch wenn das Internet mal ausfällt.",
        "feature_hardware": "Hardware Offen",
        "feature_hardware_desc": "Nutzen Sie Ihre vorhandenen Drucker, Tablets und PCs.",
        "pricing_title": "Faire Preise, volle Transparenz",
        "plan_basic": "Basic",
        "plan_pro": "Pro",
        "plan_enterprise": "Enterprise"
      }
    }
  },
  en: {
    translation: {
      "landing": {
        "hero_title": "Modern Cloud POS for your Business",
        "hero_subtitle": "Compliant, offline-capable, and incredibly easy to use. Start the future of your business today.",
        "cta_start": "Start Free Trial",
        "features_title": "Everything you need",
        "feature_fiscal": "Legal Compliance",
        "feature_fiscal_desc": "Fully integrated signatures for absolute legal peace of mind.",
        "feature_offline": "Offline Ready",
        "feature_offline_desc": "Keep working even when your internet goes down.",
        "feature_hardware": "Hardware Agnostic",
        "feature_hardware_desc": "Use your existing printers, tablets, and PCs.",
        "pricing_title": "Fair pricing, full transparency",
        "plan_basic": "Basic",
        "plan_pro": "Pro",
        "plan_enterprise": "Enterprise"
      }
    }
  },
  sq: {
    translation: {
      "landing": {
        "hero_title": "Sistemi Modern POS për Biznesin tuaj",
        "hero_subtitle": "Konform ligjit, funksionon pa internet dhe shumë i lehtë për t'u përdorur.",
        "cta_start": "Provo falas",
        "features_title": "Gjithçka që ju duhet",
        "feature_fiscal": "Konform ligjit",
        "feature_fiscal_desc": "Nënshkrime plotësisht të integruara për siguri ligjore absolute.",
        "feature_offline": "Funksionon Offline",
        "feature_offline_desc": "Vazhdoni punën edhe nëse interneti ndërpritet.",
        "feature_hardware": "Liri në Hardware",
        "feature_hardware_desc": "Përdorni printerët, tabletët dhe PC-të tuaj ekzistues.",
        "pricing_title": "Çmime korrekte, transparencë e plotë",
        "plan_basic": "Bazë",
        "plan_pro": "Pro",
        "plan_enterprise": "Ndërmarrje"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
